module.exports = __webpack_public_path__ + "img/reuseDetail.fde7a7f3.jpeg";